import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import HorizontalImageStrip from "./HorizontalImagesStrip";

import logo_icon from '../assets/logo_icon.png';
import hp1 from '../assets/banner1.jpg';
import hp2 from '../assets/banner2.jpg';
import hp3 from '../assets/banner4.jpg';
import hp4 from '../assets/banner5.jpg';
import hp5 from '../assets/banner3.jpg';
import hp6 from '../assets/banner6.jpg';
import hp7 from '../assets/banner5.jpg';
import hp8 from '../assets/banner7.jpg';
import hp9 from '../assets/banner6.jpg';
import hp10 from '../assets/banner3.jpg';


export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-primary"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					
				
					<div className="row">

						<div className="col-md-12 text-center">
							<h1
								style={{
									fontSize: "48px",
								}}
								className="font-bold text-center"
							>
								KOBE KONSULT
							</h1>
							<p className="my-5 font-semi-bold">
								Kobe Konsult supports governments, organisations, and communities across Africa with 
								management, economic, and research services. 
								
								<br />
								We help clients solve problems through practical insights, data-driven approaches, and measurable results.
							</p>
						</div>


						<div className="col-md-12">
							<HorizontalImageStrip
								images={[hp1, hp2, hp3, hp4, hp5, hp6, hp7, hp8, hp9, hp10]}
							/>

							<div className="text-center mt-5">
								<button
									className="btn btn-padded btn-light"
									onClick={() => {
										appContext.navTo({
											item: 'contact_us'
										})
									}}
								>
									Contact Kobe Konsult
								</button>
							</div>
						</div>

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
